import { SIMPLE_HQ_COMPANY_ID } from '../simple-hq/constants'

/** Spend demo rows created for The Simple Intel, named Supplier 1, Supplier 400, and so on. */
const SIMULATED_SUPPLIER_NAME = /^supplier\s+\d+$/i

let answerCompanyId: string | null = null

export function isSimulatedSupplierName(name: string | null | undefined): boolean {
  return SIMULATED_SUPPLIER_NAME.test((name ?? '').trim())
}

/** Risk Analyst reads this when it loads the roster for the company currently being answered. */
export function setSimulatedSupplierCompany(companyId: string | null | undefined): void {
  answerCompanyId = companyId ?? null
}

export function hideSimulatedSuppliers<T extends { name?: string | null }>(
  rows: T[],
  companyId?: string | null,
): T[] {
  const id = companyId === undefined ? answerCompanyId : companyId
  if (!id || id === SIMPLE_HQ_COMPANY_ID) return rows
  return rows.filter((row) => !isSimulatedSupplierName(row.name))
}
